export const frontEndSkills = [
  {
    img: "/img/icons/html5-original.svg",
    name: "HTML5",
  },
  {
    img: "/img/icons/css3-original.svg",
    name: "CSS",
  },
  {
    img: "/img/icons/javascript-original.svg",
    name: "JavaScript",
  },
  {
    img: "/img/icons/typescript.svg",
    name: "TypeScript",
  },
  {
    img: "/img/icons/jquery-original.svg",
    name: "jQuery",
  },
  {
    img: "/img/icons/react-original.svg",
    name: "React JS",
  },
];

export const uiFrameworkSkills = [
  {
    img: "/img/icons/storybook.svg",
    name: "Storybook",
  },
  {
    img: "/img/icons/antdesign.svg",
    name: "Ant Design",
  },
  {
    img: "/img/icons/materialui.svg",
    name: "Material UI",
  },
];

export const backEndSkills = [
  {
    img: "/img/icons/nodejs.svg",
    name: "Node JS",
  },
  {
    img: "/img/icons/php.svg",
    name: "PHP",
  },
  {
    img: "/img/icons/express.svg",
    name: "Express JS",
  },
  {
    img: "/img/icons/python.svg",
    name: "Python",
  },
];

export const apiSkills = [
  {
    img: "/img/icons/restapi.png",
    name: "REST APIs",
  },
  {
    img: "/img/icons/graphql.svg",
    name: "GraphQL APIs",
  },
];

export const architectureSkills = [
  {
    img: "/img/icons/monolith.svg",
    name: "Monoliths",
  },
  {
    img: "/img/icons/microservices.svg",
    name: "Microservices",
  },
  {
    img: "/img/icons/eventdriven.svg",
    name: "Event Driven",
  },
];

export const phpFrameworkSkills = [
  {
    img: "/img/icons/wordpress.svg",
    name: "WordPress",
  },
];

export const paymentGatewaySkills = [
  {
    img: "/img/icons/stripe.svg",
    name: "Stripe",
  },
  {
    img: "/img/icons/paypal.svg",
    name: "PayPal",
  },
  {
    img: "/img/icons/juspay.svg",
    name: "Juspay",
  },
  {
    img: "/img/icons/razorpay.svg",
    name: "Razorpay",
  },
];

export const databaseSkills = [
  {
    img: "/img/icons/postgresql.svg",
    name: "PostgreSQL",
  },
  {
    img: "/img/icons/mysql.svg",
    name: "MySQL",
  },
  {
    img: "/img/icons/mongodb.svg",
    name: "MongoDB",
  },
  {
    img: "/img/icons/dynamodb.svg",
    name: "DynamoDB",
  },
];

export const aiToolSkills = [
  {
    img: "/img/icons/cursor.svg",
    name: "Cursor",
  },
  {
    img: "/img/icons/githubcopilot.svg",
    name: "GitHub Copilot",
  },
  {
    img: "/img/icons/claudecode.svg",
    name: "Claude Code",
  },
  {
    img: "/img/icons/antigravity.svg",
    name: "Antigravity",
  },
  {
    img: "/img/icons/ollama.svg",
    name: "Ollama",
  },
];

export const programmingSkills = [
  {
    img: "/img/icons/python.svg",
    name: "Python",
  },
  {
    img: "/img/icons/CPP.png",
    name: "C / C++",
  },
  {
    img: "/img/icons/java.svg",
    name: "Java",
  },
];

export const otherSkills = [
  {
    img: "/img/icons/docker.svg",
    name: "Docker",
  },
  {
    img: "/img/icons/linux.svg",
    name: "Linux",
  },
  {
    img: "/img/icons/aws.svg",
    name: "AWS",
  },
  {
    img: "/img/icons/jenkins.svg",
    name: "Jenkins",
  },
];

// Backwards compatibility
export const webSkills = frontEndSkills;

// Complete Category Structure
export const skillCategories = [
  {
    id: "frontend",
    title: "Front End Technologies",
    badge: "Client-Side",
    skills: frontEndSkills,
  },
  {
    id: "ui-frameworks",
    title: "UI Frameworks / Libraries",
    badge: "Design Systems",
    skills: uiFrameworkSkills,
  },
  {
    id: "backend",
    title: "Back End Technologies",
    badge: "Server-Side",
    skills: backEndSkills,
  },
  {
    id: "apis",
    title: "APIs",
    badge: "Integration",
    skills: apiSkills,
  },
  {
    id: "architectures",
    title: "Architectures",
    badge: "System Design",
    skills: architectureSkills,
  },
  {
    id: "php-frameworks",
    title: "PHP Frameworks",
    badge: "CMS & Frameworks",
    skills: phpFrameworkSkills,
  },
  {
    id: "payment-gateways",
    title: "Payment Gateways",
    badge: "Fintech",
    skills: paymentGatewaySkills,
  },
  {
    id: "database",
    title: "Database",
    badge: "SQL & NoSQL",
    skills: databaseSkills,
  },
  {
    id: "ai-tools",
    title: "AI Tools",
    badge: "Developer Intelligence",
    skills: aiToolSkills,
  },
  {
    id: "programming-languages",
    title: "Programming Languages",
    badge: "Core Languages",
    skills: programmingSkills,
  },
  {
    id: "other-skills",
    title: "Other Skills",
    badge: "DevOps & Cloud",
    skills: otherSkills,
  },
];